import { Textarea } from "@/components/ui/textarea";

type Props = { value: any; onChange: (v: any) => void };
export default function KnowledgeStep({ value, onChange }: Props) {
  return (
    <div className="grid gap-4">
      <div>
        <label className="text-sm">Source links or notes</label>
        <Textarea
          rows={6}
          value={value.sources}
          onChange={(e)=>onChange({...value, sources:e.target.value})}
          placeholder={"One per line: \
https://boyfanz.com/creator/alex \
FAQ: DM guidelines, schedules..."}
        />
        <p className="mt-1 text-xs text-muted-foreground">URLs and plain text supported. Files require backend connection.</p>
      </div>
    </div>
  );
}
